
const enterpriseModels = [
  ['GPT 5.6', 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/AI%20Development/AI_Models/instructgpt.Woblo.webp?updatedAt=1789042567196'],
  ['Gemini 3', 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/AI%20Development/AI_Models/star.Woblo.svg?updatedAt=1789042567213'],
  ['Perplexity', 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/AI%20Development/AI_Models/perplexity.Woblo.webp?updatedAt=1789042693003'],
  ['Claude', 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/AI%20Development/AI_Models/claude_20opus.Woblo.webp?updatedAt=1789042567259'],
  ['Llama 3', 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/AI%20Development/AI_Models/llama3.Woblo.webp?updatedAt=1789042692895'],
  ['Copilot', 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/AI%20Development/AI_Models/copilot.Woblo.webp?updatedAt=1789042567132'],
  ['DALL-E', 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/AI%20Development/AI_Models/dalle.Woblo.webp?updatedAt=1789042567109'],
  ['DeepSeek', 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/AI%20Development/AI_Models/deepSeek.Woblo.webp?updatedAt=1789042567255'],
  ['Gemma', 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/AI%20Development/AI_Models/gemma.Woblo.webp?updatedAt=1789042567131'],
  ['Meta AI', 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/AI%20Development/AI_Models/Meta_20AI.Woblo.webp?updatedAt=1789042567134'],
  ['Midjourney', 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/AI%20Development/AI_Models/midjourney.Woblo.webp?updatedAt=1789042692902'],
  ['Qwen', 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/AI%20Development/AI_Models/qwen.Woblo.webp?updatedAt=1789042567120'],
  ['Amazon Nova', 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/AI%20Development/AI_Models/Amazon_20Nova.Woblo.webp?updatedAt=1789042567140'],
  ['Text to Speech', 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/AI%20Development/AI_Models/text-to-speech.Woblo.webp?updatedAt=1789042693005'],
  ['Claude Opus', 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/AI%20Development/AI_Models/claude_20opus.Woblo.webp?updatedAt=1789042567259'],
  ['Mistral', 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/AI%20Development/AI_Models/mistral.Woblo.webp?updatedAt=1789042692916'],
];

export default function EnterpriseModelShowcase() {
  return (
    <section className="px-5 py-14 sm:px-6 sm:py-16 lg:px-10 lg:py-16" style={{ background: '#FFFFFF' }}>
      <div className="mx-auto max-w-7xl">
        <div className="mx-auto max-w-6xl text-center">
          <h2 className="text-[32px] font-semibold leading-[48px]" style={{ color: '#183762' }}>
            AI models we integrate, Fine-Tune and deploy for enterprise use
          </h2>
          <p className="mx-auto mt-5 max-w-6xl text-center text-base font-normal leading-[27px] sm:mt-7" style={{ color: '#212121' }}>
            We select and adapt the models that best fit your data, workflows and desired outcomes, then prepare them for dependable use across real enterprise environments.
          </p>
        </div>

        <div className="mt-8 grid grid-cols-2 border-l border-t sm:grid-cols-4 lg:mt-10 lg:grid-cols-8" style={{ borderColor: '#DCE3EC' }}>
          {enterpriseModels.map(([name, image]) => (
            <article key={name} className="flex min-h-[98px] flex-col items-center justify-center border-b border-r px-2 py-4 text-center sm:min-h-[108px] sm:px-3" style={{ borderColor: '#DCE3EC' }}>
              <div className="flex h-9 items-center justify-center">
                {image ? <img src={image} alt={name} className="h-8 w-8 object-contain" /> : <span className="h-8 w-8" aria-hidden="true" />}
              </div>
              <h3 className="mt-3 break-words text-sm font-semibold leading-tight sm:text-base" style={{ color: '#183762' }}>{name}</h3>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
